module.exports = __webpack_public_path__ + "c38b620ca50e3d5652ed9287483a1999.png";